import * as React from 'react';
import { Link } from 'react-router';
import styled from 'styled-components';
import { rem } from 'polished';
import {
  FlexRowCenter,
  FlexColCenterHorizontal,
} from '../../Defaults/Flexbox/Flexbox';
import { TextP } from '../../Defaults/Text';
import { resolveCategoryUrl } from '../../../utilities/selectors';

export interface Props {
  id: number;
  index: number;
  name: string;
  imgSrc: string;
  bigImgSrc: string;
  url: string;
  onMouseOver?: any;
  firstLevel: boolean;
  numOfProducts?: number;
  onClick: any;
  active?: boolean;
}

function NavigationDropdownItem({
  id,
  index,
  name,
  imgSrc,
  bigImgSrc,
  url,
  onMouseOver,
  firstLevel,
  numOfProducts,
  onClick,
  active = false,
}: Props) {
  return (
    // <div onMouseOver={onMouseOver ? () => onMouseOver(index) : null}>
    // <Wrapper
    //   className={active ? 'activeItem' : ''}
    //   onClick={onClick}
    //   href={resolveCategoryUrl(id, url)}
    //   firstLevel={firstLevel}
    // >
    <Wrapper
      className={active ? 'activeItem' : ''}
      onClick={onClick}
      to={resolveCategoryUrl(id, url)}
      firstLevel={firstLevel}
      // tslint:disable-next-line:jsx-no-lambda
      onMouseOver={onMouseOver ? () => onMouseOver(index) : null}
    >
      <ImageWrapper>
        <Image alt={`Obrázok ku kategórií ${name}`} src={imgSrc} />
      </ImageWrapper>
      {bigImgSrc && (
        //   <BigImage
        //   alt={`Zväčšený obrázok ku kategórií ${name}`}
        //   src={bigImgSrc}
        // />
        <BigImageWrapper>
          <BigImage
            alt={`Zväčšený obrázok ku kategórií ${name}`}
            src={bigImgSrc}
          />
          <BigImageName>{name}</BigImageName>
        </BigImageWrapper>
      )}
      <Name className="categoryName">
        {name}{' '}
        {numOfProducts && <NumOfProducts>{`(${numOfProducts})`}</NumOfProducts>}
      </Name>
    </Wrapper>
    // </div>
  );
}

// const Wrapper = styled.a<{ firstLevel: boolean }>`
const Wrapper = styled(Link)`
  text-decoration: none;
  display: flex;
  flex-direction: row;
  align-items: center;

  width: 100%;
  padding: ${rem(4)} ${rem(24)};
  margin-bottom: ${rem(8)};

  line-height: ${rem(22)};

  &.activeItem {
    background-color: ${(props: { firstLevel: boolean; theme: any }) =>
      props.firstLevel ? '' : props.theme.colors.hover};
  }

  &.activeItem > p.categoryName {
    color: ${({ theme }) => theme.colors.primary};
  }

  &:hover {
    background-color: ${(props: { firstLevel: boolean; theme: any }) =>
      props.firstLevel ? '' : props.theme.colors.hover};
  }

  &:hover > p.categoryName {
    color: ${({ theme }) => theme.colors.primary};
  }
`;

const ImageWrapper = styled(FlexRowCenter)`
  width: ${rem(40)};
  height: ${rem(40)};
  /* padding: ${rem(4)}; */
  margin-right: ${rem(16)};
  border-radius: ${rem(2)};
  border: ${({ theme }) => theme.borders.secondary};
`;

const BigImageName = styled(TextP)`
  text-align: center;
  margin: ${rem(16)} 0;
`;

const BigImageWrapper = styled(FlexColCenterHorizontal)`
  position: absolute;
  width: ${rem(300)};
  height: ${rem(356)};
  display: none;
  margin-top: ${rem(170)};
  margin-left: ${rem(40)};
  pointer-events: none;
  border-radius: ${rem(8)};
  background-color: white;
  position: fixed;
  left: 50%;
  top: 50%;
  margin: 0;
  transform: translate(-50%, -50%);
  box-shadow: ${({ theme }) => theme.boxShadow.secondary};
  z-index: 100;
  ${ImageWrapper}:hover ~ & {
    display: block;
  }
`;

const BigImage = styled.img`
  /* position: absolute;
  width: ${rem(300)};
  height: ${rem(300)};
  display: none;
  margin-top: ${rem(170)};
  margin-left: ${rem(40)};
  pointer-events: none;
  border-radius: ${rem(8)};
  background-color: white; */

  /* position: fixed;
  left: 50%;
  top: 50%;
  margin: 0;
  transform: translate(-50%, -50%);
  box-shadow: ${({ theme }) => theme.boxShadow.secondary};
  z-index: 100; */

  ${ImageWrapper}:hover ~ & {
    display: block;
  }
`;

const Image = styled.img`
  width: 100%;
  height: 100%;
`;

const Name = styled(TextP)`
  font-weight: 400;
  color: ${({ theme }) => theme.colors.textPrimary};
  font-size: ${rem(14)};
  max-width: ${rem(192)};
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
`;

const NumOfProducts = styled.span`
  color: ${({ theme }) => theme.colors.inactiveFontColor};
  font-family: ${({ theme }) => theme.font.tertiary};
  font-weight: 400;
  font-size: ${rem(14)};
  /* margin-left: ${rem(7)}; */
`;

function areEqual(prev: Props, next: Props) {
  return (
    prev.url === next.url &&
    prev.name === next.name &&
    prev.active === next.active
  );
}
const WithThemeNavigationDropdownItem: any = React.memo(
  NavigationDropdownItem,
  areEqual,
);
export { WithThemeNavigationDropdownItem as NavigationDropdownItem };
